import styled from "styled-components";
import {PrimaryButton} from "../../../basic-components/buttons/primary-button";

export const SaveButtonBox = styled(PrimaryButton)`
`
